//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
import Vue from 'vue'
// import moment from 'moment'
// import DIC from '@/index/dictonary'

export default {
  components: {
  },
  data: function () {
    return {
      form: {
        bid: undefined,
        cid: undefined,
        images: [],
        info: undefined,
        model: '',
        name: '',
        price: 0,
        cashBackMoney: 0,
        size: ''
      },
      brandOptions: [],
      categoryOptions: [],
      rules: {
      },
      loading: false,
      successDialogVisible: false
    }
  },
  mounted () {
    let p1 = new Promise((resolve, reject) => {
      this.$axios.get('/mtea/store/admin/goods/category/list', { params: {} }).then(res => {
        this.categoryOptions = res
      }).finally(() => {
        resolve()
      })
    })
    let p2 = new Promise((resolve, reject) => {
      this.$axios.get('/mtea/store/admin/goods/brand/list', { params: {} }).then(res => {
        this.brandOptions = res
      }).finally(() => {
        resolve()
      })
    })
    Promise.all([p1, p2]).then(() => {
    })
  },
  methods: {
    handleFormSubmit () {
      this.$refs.form.validate((valid) => {
        // console.log('valid', valid)
        if (valid) {
          let data = _.extend({}, _.omit(this.form, 'images'))
          // console.log('data', data, JSON.stringify(data))
          if (this.form.images.length > 0) {
            data.images = this.form.images.toString()
          }
          this.loading = true
          // console.log('data', data)
          this.$axios.post('/mtea/store/admin/goods/add', data).then(res => {
            this.successDialogVisible = true
          }).finally(() => {
            this.loading = false
          })
          // this.loading = false
        } else {
          this.$notify.error({
            title: '错误',
            message: '表单校验失败'
          })
        }
      })
      /**/
    }
  }
}
